import { Directive, EventEmitter, ElementRef, HostListener, Input, Output } from '@angular/core';
import { FileItem } from '../models/FileItem';
@Directive({
  selector: '[appNgDropFiles]'
})
export class NgDropFilesDirective {
  @Input() archivos: FileItem[];
  @Output() mouseOver: EventEmitter<boolean> = new EventEmitter();
  constructor() { }

  @HostListener('dragover', ['$event'])
  public onDragEnter( event: any ) {
    this.mouseOver.emit( true );
    this._noAbrir( event );
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave( event: any ) {
    this.mouseOver.emit( false );
    this._noAbrir( event );
  }

  @HostListener('drop', ['$event'])
  public onDrop( event: any ) {

    const transferencia = this._cargarTransferencia( event );

    if (!transferencia) {
      return;
    }

    console.log(transferencia);
    // this._extraerArchivos(transferencia.files);
    this._noAbrir( event );
    this.mouseOver.emit( false );
  }

  private _extraerArchivos( archivos: FileList ) {
    // console.log(archivos);
    // tslint:disable-next-line:forin
    for ( const i in Object.getOwnPropertyNames( archivos ) ) {
      const archivoTemporal = archivos[i];
      if (this._subirArchivo(archivoTemporal)) {
        const nuevoArchivo = new FileItem(archivoTemporal);
        this.archivos.push(nuevoArchivo);
      }
    }

    console.log(archivos);
  }

  private _cargarTransferencia( event: any ) {
    console.log(event);
    return (event.dataTransfer) ? event.dataTransfer : event.originalEvent.dataTransfer;
  }

  // Impedir que el navegador abra los archivos droppeados
  private _noAbrir( event ) {
    event.preventDefault();
    event.stopPropagation();
  }

  // Impedir que se guarde 2 veces el mismo archivo en la variable
  private _exiteArchivo( nombreArchivo: string ): boolean {
    for (const archivo of this.archivos) {
      if ( archivo.nombreArchivo === nombreArchivo ) {
        return true;
      }
    }

    return false;
  }

  // Validar tipo de archivo
  private _tipoArchivo( tipoArchivo: string ): boolean {
    if (tipoArchivo.startsWith('image/') ||
        tipoArchivo === 'application/pdf' ||
        tipoArchivo === 'application/vnd.ms-excel' ||
        tipoArchivo === 'application/msword' ||
        tipoArchivo === 'video/mp4' ||
        tipoArchivo === 'video/webm' ||
        tipoArchivo === 'video/3gpp' ||
        tipoArchivo === 'video/3gpp2') {
      return true;
    } else {
      return false;
    }
  }

  // Validar si el archivo se puede subir
  private _subirArchivo( archivo: File): boolean {
    if (!this._exiteArchivo( archivo.name ) && this._tipoArchivo(archivo.type)) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/directivas/ng-drop-files.directive.ts